import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UserStateService {
  // Initialize signals from localStorage or empty strings
  employeeName: WritableSignal<string> = signal(localStorage.getItem('employeeName') || '');
  companyId: WritableSignal<string> = signal(localStorage.getItem('companyId') || '');

  // Setter functions that update both signal and localStorage
  setEmployeeName(name: string) {
    this.employeeName.set(name);
    localStorage.setItem('employeeName', name);
  }
  setCompanyId(id: string) {
    this.companyId.set(id);
    localStorage.setItem('companyId', id);
  }
}
